function DDUMainLeaderboard({value, leaderboard}) {
    const renderLeaderboard = () => {
        const PLAYER_FULL_NAME = `${value["player-name"]} ${value["player-surname"]}`;
        const MAX_ROWS = 9;

        const playerIndex = leaderboard.findIndex(d => d.name === PLAYER_FULL_NAME);

        let start = 0;
        if (playerIndex >= MAX_ROWS) {
            start = Math.max(0, playerIndex - (MAX_ROWS - 1));
        }
        
        const visibleDrivers = leaderboard.slice(start, start + MAX_ROWS);

        const displayRows = [...visibleDrivers];
        while (displayRows.length < MAX_ROWS) {
            displayRows.push({ isDummy: true, id: `empty-${displayRows.length}` });
        }

        return displayRows.map((driver, index) => {
            if (driver.isDummy) {
                return (
                    <tr key={driver.id} className="h-[40px] opacity-20">
                        <td colSpan="5"><div className="ml-4">-</div></td>
                    </tr>
                );
            }

            const isPlayer = driver.name === PLAYER_FULL_NAME;

            return (
                <tr key={driver["car-id"]}>
                    <td>
                        <div className="flex items-center gap-4">
                            <span className={`${isPlayer ? "bg-[#63aafe] text-white" : "bg-white text-black"} flex items-center justify-center min-w-[20px] h-[23px] rounded ml-[10px] px-1 text-xs font-bold`}>
                                {driver.position}
                            </span>
                            <p className={`${isPlayer ? "text-[#3b82f6]" : "text-white"} font-bold`}>#{driver["car-number"]}</p>
                            <p className={`${isPlayer ? "text-[#3b82f6]" : "text-white"} font-bold uppercase`}>{driver.name}</p>
                        </div>
                    </td>
                    <td>
                        <div className="flex justify-center">
                            <p>{driver.position === 1 ? "-" : `${driver.gap >= 0 ? "+" : ""}${driver.gap}s`}</p>
                        </div>
                    </td>
                    <td>
                        <div className="flex justify-center">
                            <p className={`${driver["has-best-lap"] ? "text-[#c231f1]" : "text-white"}`}>{driver["best-lap"]}</p>
                        </div>
                    </td>
                    <td>
                        <div className="flex justify-center"><p>{driver["last-lap"]}</p></div>
                    </td>
                    <td>
                        <div className="flex justify-center"><p>{driver.pits}</p></div>
                    </td>
                </tr>
            );
        });
    };

    return (
        <table className="dash-leaderborad-table w-full h-full">
            <thead>
                <tr>
                    <th>Relative</th>
                    <th>Gap</th>
                    <th>Best</th>
                    <th>Last</th>
                    <th>Pits</th>
                </tr>
            </thead>

            <tbody>
                {renderLeaderboard()}
            </tbody>
        </table>
    );
}

export default DDUMainLeaderboard;